import { Locale } from './config';

const formatLocale = (locale: Locale) => {
  if (locale === 'ar_SA') {
    return 'ar-SA-u-nu-latn-ca-gregory';
  }
  return locale.replace('_', '-');
};

export default formatLocale;
